import { createSelector } from "reselect";

const options = (state) => {
  // currentView contains the view data directly
  return state.designChapter.currentView?.options || [];
};

export const getDesignChapterOptions = createSelector(
  [options],
  (options) => options
);

const viewType = (state) => {
  // currentView is an object, extract viewType from it
  return state.designChapter.currentView?.viewType;
};

export const getViewTypeForStepOptions = createSelector(
  [viewType],
  (viewType) => viewType
);
